<template lang="pug">
  div
    Section1Widget(to="/")
    b-card.text-left
      b-card-title {{tlang('make_appointment.title')}}

      b-card-text
        b-form(v-if='!saved')
          p {{tlang('make_appointment.date_slot_header')}}
          b-form-group(:label="tlang('make_appointment.date_field_text')" label-cols="4" label-align="left")
            b-form-select( id="date"
              v-model="appointment.date"
              required
              :options="JSON.parse( tlang('make_appointment.date_dropdown_options') )")
          b-form-group(:label="tlang('make_appointment.time_field_text')" label-cols="4" label-align="left")
            b-form-select( id="time"
              v-model="appointment.time"
              required
              :options="JSON.parse( tlang('make_appointment.time_dropdown_options') )")
          b-form-group(:label="tlang('make_appointment.first_name_field_text')" label-cols="4" label-align="left")
            b-form-input( id="first_name"
              type="text"
              v-model="appointment.first_name"
              required)
          b-form-group(:label="tlang('make_appointment.last_name_field_text')" label-cols="4" label-align="left")
            b-form-input( id="last_name"
              type="text"
              v-model="appointment.last_name"
              required)
          b-form-group(:label="tlang('make_appointment.mobile_phone_field_text')" label-cols="4" label-align="left")
            b-form-input( id="mobile_phone"
              type="tel"
              v-model="appointment.mobile_phone"
              required)
              b-form-group(:label="tlang('make_appointment.email_field_text')" label-cols="4" label-align="left")
          b-form-group(:label="tlang('make_appointment.email_field_text')" label-cols="4" label-align="left")
            b-form-input( id="email"
              type="email"
              v-model="appointment.email"
              required)
          b-button.font-weight-bold(@click="createAppointment" pill variant="primary" :disabled='!validData') {{tlang('make_appointment.submit_button_text')}}
        p(v-if='saved') {{tlang('make_appointment.confirmation_text')}}
</template>

<script>
import Section1Widget from './components/Section1Widget.vue'
import {ApiError} from './common/Api'
import ApiHandlingMixin from './common/ApiHandlingMixin'
import LangMixin from './common/lang/util'
import Joi from 'joi'

export default {
  mixins: [ApiHandlingMixin,LangMixin],
  name: 'MakeAppointment',
  components: {
    Section1Widget,
  },
  data: function(){
    return {
      saved: false,
      appointment: {
        date: null,
        time: null,
        first_name: null,
        last_name: null,
        email: null,
        mobile_phone: null,
        contact_id: null,
      },
    }
  },
  computed: {
    validData: function(){
      //email or phone
      if(!this.appointment.email && !this.appointment.mobile_phone) return false;

      //Do the rest of the validaiton.
      let appointmentFormSchema = Joi.object({
        contact_id: Joi.number().integer().allow(null),
        first_name: Joi.string().max(255).required().label("first name"),
        last_name: Joi.string().max(255).required().label("last name"),
        date: Joi.string().isoDate().required(),
        time: Joi.string().max(8).required(),
        mobile_phone: Joi.string().min(10).max(255).allow('',null).label("mobile phone"),
        email: Joi.string().email({ tlds: { allow: false } }).max(255).allow('',null).max(255),
      }).label("appointment");

      let validation = appointmentFormSchema.validate(this.appointment);
      return validation.error ? false : true;
      
    },
  },
  methods: {
    validationMessage: function(key){
      return this.errors && this.errors[key] ? this.errors[key] : '';
    },
    isValid:  function(key){
      if( this.validationMessage(key) === '' ) return null;
      return false;
    },
    createAppointment : async function(){
      try{
        this.in_process ++;
        this.resetMessageState();
        await this.$mobileapi.createAppointment(this.appointment);
        this.saved = true;
        this.message = this.tlang('make_appointment.confirmation_text');
            
      }catch(ex){
        if(ex instanceof ApiError){
          if(ex.status === 422){
            //Dupe.
            this.message = this.tlang('make_appointment.confirmation_text');
            this.saved = true;
          } else {
            //Other API
            this.message = ex.message;
            this.error = ex.details ? ex.details.error : null;
            this.errors = ex.details ? ex.details.errors : null;
          }
        } else {
          //non API
          console.error(ex);
          this.message = ex.message;
        }
      } finally {
        this.in_process--;
      }
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
